module.exports = "https://assets.bwbx.io/s3/syn/mercury/images/09146e15b5a5ae2f5ee4e7240366724f.svg";